module.exports = __webpack_public_path__ + "img/pic_actionExplain.ff2bd210.png";